module.exports = __webpack_public_path__ + "img/core5.746053dd.png";